import { useLang } from "../../context/LanguageContext";
import { useSite } from "../../context/SiteContext";
import { ChevronDown } from "lucide-react";

export default function Hero() {
  const { t } = useLang();
  const { site } = useSite();
  const go = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      id="home"
      className="relative min-h-screen w-full overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage: `url('${site.hero_image || "/photos/hero.jpg"}')`,
        }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center px-4 sm:px-6 pt-20 pb-12">
        <p
          data-testid="hero-overline"
          className="animate-fade-up uppercase text-[10px] sm:text-sm tracking-[0.3em] sm:tracking-[0.35em] text-white/90 mb-5 sm:mb-8"
        >
          {t.hero.overline}
        </p>
        <h1
          data-testid="hero-title"
          className="animate-fade-up delay-100 font-serif text-white text-4xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-5xl"
        >
          {t.hero.title}
        </h1>
        <p
          data-testid="hero-subtitle"
          className="animate-fade-up delay-200 mt-4 sm:mt-6 font-serif italic text-white/95 text-lg sm:text-2xl lg:text-3xl"
        >
          {t.hero.subtitle}
        </p>
        <p
          data-testid="hero-tagline"
          className="animate-fade-up delay-300 mt-5 sm:mt-8 max-w-2xl text-white/85 text-sm sm:text-lg leading-relaxed font-light"
        >
          {t.hero.tagline}
        </p>

        <div className="animate-fade-up delay-400 mt-8 sm:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto max-w-sm sm:max-w-none">
          <button
            onClick={() => go("#booking")}
            data-testid="hero-book-now-btn"
            className="bg-white text-[#1A2B4C] px-7 sm:px-10 py-3.5 sm:py-4 rounded-full text-xs sm:text-sm tracking-[0.15em] uppercase hover:-translate-y-0.5 transition-transform shadow-xl"
          >
            {t.hero.bookNow}
          </button>
          <button
            onClick={() => go("#apartments")}
            data-testid="hero-view-apartments-btn"
            className="border border-white/60 text-white px-7 sm:px-10 py-3.5 sm:py-4 rounded-full text-xs sm:text-sm tracking-[0.15em] uppercase hover:bg-white/10 transition-all"
          >
            {t.hero.viewApartments}
          </button>
          <button
            onClick={() => go("#contact")}
            data-testid="hero-contact-us-btn"
            className="border border-white/60 text-white px-7 sm:px-10 py-3.5 sm:py-4 rounded-full text-xs sm:text-sm tracking-[0.15em] uppercase hover:bg-white/10 transition-all"
          >
            {t.hero.contactUs}
          </button>
        </div>

        <button
          onClick={() => go("#apartments")}
          className="absolute bottom-10 text-white/70 animate-bounce"
          aria-label="Scroll down"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      </div>
    </section>
  );
}
